import { createElementBlock as l, openBlock as r, createElementVNode as o } from "vue";
const n = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
};
function t(c, e) {
  return r(), l("svg", n, e[0] || (e[0] = [
    o("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M16.334 2.57a1 1 0 0 0-.667 1.885A8 8 0 1 1 5.16 10.402l.449 1.019a1 1 0 1 0 1.83-.807l-1.384-3.14a1 1 0 0 0-1.318-.511l-3.14 1.384a1 1 0 0 0 .807 1.83l.838-.37C3.083 10.515 3 11.249 3 12c0 5.523 4.477 10 10 10s10-4.477 10-10c0-4.356-2.784-8.058-6.666-9.43M14.206 7a1 1 0 1 0-2 0v4.984l-2.595 1.095a1 1 0 1 0 .778 1.842l3.817-1.61z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const d = { render: t };
export {
  d as default,
  t as render
};
//# sourceMappingURL=ic_reserve-Zr-WN7_Z.js.map
